// extracted by mini-css-extract-plugin
export default {"root":"_2vQ_-","variant-subscriptions":"UIXap","variantSubscriptions":"UIXap","variant-adoptables":"_4dl-U","variantAdoptables":"_4dl-U"};